document.addEventListener('DOMContentLoaded', function () {
 
    
    /// Add back to top button focus 

 // ===== Third party links =====
  function updateThirdPartyLinks() {
    const suffix = "Redirecting to thirdparty, opens in a new tab";

    document.querySelectorAll("a[href^='http']").forEach(a => {
      if (a.hostname === location.hostname) return;

      const label = a.getAttribute("aria-label") || a.textContent.trim() || a.title || "Link";
      if (!label.includes(suffix)) {
        a.setAttribute("aria-label", `${label}, ${suffix}`);
      }
    });
  }

  updateThirdPartyLinks(); // <-- this was missing

//////////============================================== Mobile and email js 
document.querySelectorAll('a[href^="mailto:"], a[href^="tel:"]').forEach(el => {
  if (el.hasAttribute('aria-label')) return;

  const text = el.textContent.trim();
  const label = el.href.startsWith('mailto:') ? 'Email us' : 'Phone us';

  el.setAttribute('aria-label', text ? `${label} ${text}` : label);
});


// ===== Cart drawer focus management =====
const drawer = document.getElementById('halo-cart-sidebar');
let lastFocus = null;

if (drawer) {
  drawer.setAttribute('role', 'dialog');
  drawer.setAttribute('aria-modal', 'true');
  drawer.setAttribute('aria-label', 'Shopping cart');

  const focusables = () =>
    [...drawer.querySelectorAll('a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])')]
      .filter(el => !el.disabled && el.offsetParent !== null);

  // Remember the element that was focused before the drawer opened
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('.product-form__submit, [data-open-cart-sidebar]');
    if (trigger) lastFocus = trigger;
  });

  // Open / close detection
  let wasOpen = document.body.classList.contains('cart-sidebar-show');

  new MutationObserver(() => {
    const isOpen = document.body.classList.contains('cart-sidebar-show');
    if (isOpen === wasOpen) return;
    wasOpen = isOpen;

    if (isOpen) {
      if (!lastFocus) lastFocus = document.activeElement;
      setTimeout(() => {
        const closeBtn = drawer.querySelector('[data-close-cart-sidebar]');
        (closeBtn || drawer).focus();
      }, 100);
    } else if (lastFocus) {
      lastFocus.focus();
      lastFocus = null;
    }
  }).observe(document.body, { attributes: true, attributeFilter: ['class'] });

  // Focus trap + Escape
  drawer.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      drawer.querySelector('[data-close-cart-sidebar]')?.click();
      return;
    }

    if (e.key !== 'Tab') return;
    const items = focusables();
    if (!items.length) return;

    const first = items[0];
    const last = items[items.length - 1];

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }

  });
}


// CLick base menu 

document.querySelectorAll('.menu-lv-item.dropdown').forEach((item, index) => {
    const trigger = item.querySelector(':scope > a, :scope > button');
    const submenu = item.querySelector(':scope > .header__submenu, :scope > ul');

    if (!trigger || !submenu) return;

    // Set up accessibility attributes
    submenu.id ||= `menu-submenu-${index}`;
    trigger.setAttribute('aria-controls', submenu.id);
    trigger.setAttribute('aria-expanded', 'false');
    trigger.setAttribute('tabindex', '0');

    if (trigger.tagName === 'A') {
        trigger.removeAttribute('href');
        trigger.setAttribute('role', 'button');
    }

    submenu.hidden = true;

    // Open or close the submenu
    function toggleMenu(open) {
        if (open) {
            // Close other dropdowns, but keep parent menus open
            document.querySelectorAll('.menu-lv-item.dropdown').forEach(other => {
                if (other === item || other.contains(item)) return;

                const otherTrigger = other.querySelector(':scope > a, :scope > button');
                const otherSubmenu = other.querySelector(':scope > .header__submenu, :scope > ul');

                if (otherTrigger && otherSubmenu) {
                    otherTrigger.setAttribute('aria-expanded', 'false');
                    otherSubmenu.hidden = true;
                    other.classList.remove('is-open', 'is-expanded');
                }
            });
        }

        trigger.setAttribute('aria-expanded', String(open));
        submenu.hidden = !open;
        item.classList.toggle('is-open', open);
        item.classList.toggle('is-expanded', open);
    }

    // Mouse, touch, and click activation
    trigger.addEventListener('click', event => {
        event.preventDefault();
        toggleMenu(trigger.getAttribute('aria-expanded') !== 'true');
    });

    // Keyboard support
    trigger.addEventListener('keydown', event => {
        const isOpen = trigger.getAttribute('aria-expanded') === 'true';

        if (event.key === 'Enter' || event.key === ' ') {
            if (trigger.tagName === 'BUTTON') return;

            event.preventDefault();
            toggleMenu(!isOpen);
        }

        if (event.key === 'ArrowDown') {
            event.preventDefault();
            toggleMenu(true);
            submenu.querySelector('a[href]:not(.d-none)')?.focus();
        }

        if (event.key === 'Escape' && isOpen) {
            event.preventDefault();
            toggleMenu(false);
            trigger.focus();
        }
    });

    // Escape from inside the submenu
    submenu.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
            event.preventDefault();
            toggleMenu(false);
            trigger.focus();
        }
    });
});


///////////////////////======================================= Js for producat tab panel descriotuon info 
document.querySelectorAll('product-tab .tabs-horizontal .tab-title').forEach(function (tab) {
  tab.setAttribute('role', 'tab');

  function updateSelected() {
    tab.setAttribute(
      'aria-selected',
      tab.classList.contains('is-open') ? 'true' : 'false'
    );
  }

  updateSelected();

  new MutationObserver(updateSelected).observe(tab, {
    attributes: true,
    attributeFilter: ['class']
  });
});




document.querySelectorAll('product-tab').forEach(function (component) {
  const tabs = component.querySelectorAll('.tabs-horizontal .tab-title');
  const panels = component.querySelectorAll('.tabs-contents > .tab-content');

  tabs.forEach(function (tab) {
    const panelId = tab.getAttribute('href');

    if (!panelId || !panelId.startsWith('#')) return;

    const panel = component.querySelector(panelId);
    if (!panel) return;

    // Give the tab a unique ID if missing
    if (!tab.id) {
      tab.id = 'product-tab-' + panel.id.replace('tab-', '');
    }

    tab.setAttribute('role', 'tab');
    tab.setAttribute('aria-controls', panel.id);

    // Name the content panel after its corresponding tab
    panel.setAttribute('role', 'tabpanel');
    panel.setAttribute('aria-labelledby', tab.id);
  });
});




//////////////////////////////////////////////////////////////// Mobile menu js 

/*!

* Mobile menu accessibility enhancement – Hollywood Fashion Secrets

* File: assets/mobile-menu-a11y.js

* Load AFTER the theme's own scripts (see theme.liquid snippet in the notes).

* Does not replace theme logic: it listens to the classes the theme already

* toggles (body.menu_open, li.menu-lv-1.is-open) and adds the missing a11y layer.

*/

(function () {

  'use strict';
 
  var OPEN_BODY_CLASS = 'menu_open';

  var SUB_OPEN_CLASS = 'is-open';
 
  // Panels slide in with a visibility transition; an element can't take focus

  // until it is visible, so retry briefly instead of a single rAF.

  function focusWhenReady(el) {

    if (!el) return;

    var tries = 0;

    (function attempt() {

      el.focus();

      if (document.activeElement !== el && tries++ < 20) setTimeout(attempt, 50);

    })();

  }
 
  function init() {

    var drawer = document.getElementById('navigation-mobile');

    var toggle = document.querySelector('button.mobileMenu-toggle');

    if (!drawer || !toggle || drawer.dataset.a11yReady) return;

    drawer.dataset.a11yReady = 'true';
 
    var closeBtn = drawer.querySelector('.halo-sidebar-close');

    var heading = drawer.querySelector('.menu-heading-mobile .title');

    var nav = drawer.querySelector('nav');

    var inertedSiblings = [];

    var isOpen = false;
 
    /* 1. Drawer = modal dialog, closed state removed from tab order/AT */

    drawer.setAttribute('role', 'dialog');

    drawer.setAttribute('aria-modal', 'true');

    if (heading) {

      heading.id = heading.id || 'navigation-mobile-title';

      drawer.setAttribute('aria-labelledby', heading.id);

    } else {

      drawer.setAttribute('aria-label', 'Menu');

    }

    if (nav) nav.setAttribute('aria-label', 'Main menu');

    drawer.inert = true;
 
    toggle.setAttribute('aria-controls', 'navigation-mobile');

    toggle.setAttribute('aria-expanded', 'false');

    if (closeBtn) closeBtn.setAttribute('aria-label', 'Close menu');
 
    /* 2. Sub-menus: unique IDs, correct aria-controls/expanded, real buttons */

    var items = drawer.querySelectorAll('li.menu-lv-1');

    Array.prototype.forEach.call(items, function (li, i) {

      var trigger = li.querySelector(':scope > .menu-lv-1__action[aria-controls]');

      var sub = li.querySelector(':scope > .header__submenu');

      if (!trigger || !sub) return;
 
      // Desktop menu already uses menu-submenu-N -> duplicate IDs. Rename mobile copies.

      var id = 'mobile-submenu-' + i;

      sub.id = id;

      sub.removeAttribute('hidden'); // theme CSS overrides it; visibility does the hiding

      trigger.setAttribute('aria-controls', id);

      trigger.setAttribute('aria-expanded', 'false');

      sub.setAttribute('aria-label', trigger.textContent.trim());
 
      // role="button" on <a href="#">: Space must activate it too

      trigger.addEventListener('keydown', function (e) {

        if (e.key === ' ' || e.key === 'Spacebar') {

          e.preventDefault();

          trigger.click();

        }

      });
 
      // Back control: <div tabindex="-1"> -> keyboard-operable button

      var back = sub.querySelector('.nav-title-mobile');

      if (back) {

        back.setAttribute('role', 'button');

        back.setAttribute('tabindex', '0');

        back.setAttribute('aria-label', 'Back to main menu');

        Array.prototype.forEach.call(back.querySelectorAll('svg'), function (svg) {

          svg.setAttribute('aria-hidden', 'true');

          svg.setAttribute('focusable', 'false');

        });

        back.addEventListener('keydown', function (e) {

          if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {

            e.preventDefault();

            back.click();

          }

        });

      }

    });
 
    /* 3. Open / close of the drawer (theme toggles body.menu_open) */

    function onOpen() {

      drawer.inert = false;

      toggle.setAttribute('aria-expanded', 'true');
 
      inertedSiblings = Array.prototype.filter.call(document.body.children, function (el) {

        return el !== drawer &&

          !el.contains(drawer) &&

          !el.inert &&

          !/^(SCRIPT|STYLE|LINK|TEMPLATE)$/.test(el.tagName) &&

          !el.classList.contains('background-overlay'); // keep tap-outside-to-close working

      });

      inertedSiblings.forEach(function (el) { el.inert = true; });
 
      focusWhenReady(closeBtn || drawer.querySelector('a[href], [role="button"]'));

    }
 
    function onClose() {

      inertedSiblings.forEach(function (el) { el.inert = false; });

      inertedSiblings = [];

      toggle.setAttribute('aria-expanded', 'false');

      var focusWasInside = drawer.contains(document.activeElement) ||

        document.activeElement === document.body;

      drawer.inert = true;

      if (focusWasInside) toggle.focus();

    }
 
    new MutationObserver(function () {

      var open = document.body.classList.contains(OPEN_BODY_CLASS);

      if (open === isOpen) return;

      isOpen = open;

      if (open) { onOpen(); } else { onClose(); }

    }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
 
    /* 4. Sub-menu state sync (theme toggles li.menu-lv-1.is-open) */

    new MutationObserver(function (mutations) {

      mutations.forEach(function (m) {

        var li = m.target;

        if (!li.matches || !li.matches('li.menu-lv-1')) return;

        var trigger = li.querySelector(':scope > .menu-lv-1__action[aria-controls]');

        var sub = li.querySelector(':scope > .header__submenu');

        if (!trigger || !sub) return;
 
        var subOpen = li.classList.contains(SUB_OPEN_CLASS);

        if (trigger.getAttribute('aria-expanded') === String(subOpen)) return;

        trigger.setAttribute('aria-expanded', String(subOpen));
 
        if (subOpen) {

          trigger.setAttribute('tabindex', '-1'); // covered by the panel

          var back = sub.querySelector('.nav-title-mobile');

          focusWhenReady(back || sub.querySelector('a[href]'));

        } else {

          trigger.setAttribute('tabindex', '0');

          if (sub.contains(document.activeElement) || document.activeElement === document.body) {

            trigger.focus();

          }

        }

      });

    }).observe(drawer, { attributes: true, attributeFilter: ['class'], subtree: true });
 
    /* 5. Escape + focus wrap inside the open drawer */

    drawer.addEventListener('keydown', function (e) {

      if (!isOpen) return;
 
      if (e.key === 'Escape' || e.key === 'Esc') {

        e.preventDefault();

        var openLi = drawer.querySelector('li.menu-lv-1.' + SUB_OPEN_CLASS);

        var openBack = openLi && openLi.querySelector('.nav-title-mobile');

        if (openBack) { openBack.click(); } else if (closeBtn) { closeBtn.click(); }

        return;

      }
 
      if (e.key !== 'Tab') return;

      var focusables = Array.prototype.filter.call(

        drawer.querySelectorAll('a[href], button:not([disabled]), input, select, [tabindex]:not([tabindex="-1"])'),

        function (el) {

          var cs = getComputedStyle(el);

          return el.getClientRects().length && cs.visibility !== 'hidden';

        }

      );

      if (!focusables.length) return;

      var first = focusables[0];

      var last = focusables[focusables.length - 1];

      if (e.shiftKey && document.activeElement === first) {

        e.preventDefault(); last.focus();

      } else if (!e.shiftKey && document.activeElement === last) {

        e.preventDefault(); first.focus();

      }

    });

  }
 
  if (document.readyState === 'loading') {

    document.addEventListener('DOMContentLoaded', init);

  } else {

    init();

  }

})();
 
  
/// ================ Js for slider best seller 
/*

* carousel-a11y.js

* Accessibility layer for the Slick "Pairs Well With" product carousel.

*

* - Only the visible (slick-active) slides are focusable and exposed to screen readers.

*   Off-screen and cloned slides get inert + aria-hidden + tabindex="-1".

* - Tab order becomes: Previous button -> visible product(s) -> Next button.

* - Focus stays on Previous/Next after a click; a polite live region announces

*   the newly visible product(s).

* - Slick's aria-live on .slick-list is removed (it caused whole-track announcements).

*

* Load after jQuery + Slick (e.g. with `defer` at the end of theme.liquid).

*/

// (function () {

//   'use strict';
 
//   /* Limit to the product recommendations section. Widen to '.products-carousel'

//      to apply it to every product carousel in the theme. */

//   var SELECTOR = '[id*="__product-recommendations"] .products-carousel';
 
//   /* The image link (.card-link) duplicates the title link and has no accessible

//      name (its images use alt=""). true = remove it from Tab order and the

//      accessibility tree; the title link stays. */

//   var HIDE_DUPLICATE_IMAGE_LINK = false;
 
//   var FOCUSABLE = 'a[href], button, input:not([type="hidden"]), select, textarea, [tabindex]';

//   var uid = 0;
 
//   function onReady(fn) {

//     if (document.readyState !== 'loading') fn();

//     else document.addEventListener('DOMContentLoaded', fn);

//   }
 
//   function getSlick(slider) {

//     try { return window.jQuery(slider).slick('getSlick'); } catch (e) { return null; }

//   }
 
//   function liveRegion(slider) {

//     var region = slider.parentNode.querySelector('.carousel-a11y-status');

//     if (!region) {

//       region = document.createElement('div');

//       region.className = 'carousel-a11y-status';

//       region.setAttribute('role', 'status');

//       region.setAttribute('aria-live', 'polite');

//       region.setAttribute('aria-atomic', 'true');

//       region.style.cssText =

//         'position:absolute!important;width:1px;height:1px;padding:0;margin:-1px;' +

//         'overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0;';

//       slider.parentNode.insertBefore(region, slider.nextSibling);

//     }

//     return region;

//   }
 
//   function setup(slider) {

//     var list = slider.querySelector('.slick-list');

//     var track = slider.querySelector('.slick-track');

//     var heading = slider.closest('.wrapper-container, .shopify-section');

//     var title = heading && heading.querySelector('.halo-block-header .title');

//     var label = title ? title.textContent.trim() : 'Products';
 
//     if (track && !track.id) track.id = 'carousel-track-' + (++uid);
 
//     slider.setAttribute('role', 'region');

//     slider.setAttribute('aria-roledescription', 'carousel');

//     slider.setAttribute('aria-label', label);

//     if (list) list.removeAttribute('aria-live');
 
//     var prev = slider.querySelector('.slick-prev');

//     var next = slider.querySelector('.slick-next');

//     if (prev) {

//       prev.setAttribute('aria-label', 'Previous products');

//       if (track) prev.setAttribute('aria-controls', track.id);

//     }

//     if (next) {

//       next.setAttribute('aria-label', 'Next products');

//       if (track) next.setAttribute('aria-controls', track.id);

//     }

//     liveRegion(slider);

//   }
 
//   function slideTitle(slide) {

//     var t = slide.querySelector('.card-title');

//     return t ? t.textContent.replace(/\s+/g, ' ').trim() : '';

//   }
 
//   function update(slider, announce) {

//     var slick = getSlick(slider);

//     if (!slick) return;
 
//     var total = slick.slideCount;

//     var slides = slider.querySelectorAll('.slick-slide');

//     var list = slider.querySelector('.slick-list');

//     var active = [];

//     var focusLost = false;
 
//     if (list) list.removeAttribute('aria-live'); // Slick re-adds it after each change
 
//     Array.prototype.forEach.call(slides, function (slide) {

//       var isActive = slide.classList.contains('slick-active');

//       var raw = parseInt(slide.getAttribute('data-slick-index'), 10) || 0;

//       var position = ((raw % total) + total) % total + 1;
 
//       slide.setAttribute('role', 'group');

//       slide.setAttribute('aria-roledescription', 'slide');

//       slide.setAttribute('aria-label', position + ' of ' + total);

//       slide.removeAttribute('tabindex');
 
//       if (!isActive && slide.contains(document.activeElement)) focusLost = true;
 
//       if (isActive) {

//         slide.removeAttribute('aria-hidden');

//         slide.inert = false;

//         active.push({ position: position, title: slideTitle(slide) });

//       } else {

//         slide.setAttribute('aria-hidden', 'true');

//         slide.inert = true;

//       }
 
//       Array.prototype.forEach.call(slide.querySelectorAll(FOCUSABLE), function (el) {

//         var isImageLink = HIDE_DUPLICATE_IMAGE_LINK && el.classList.contains('card-link');

//         if (isActive && !isImageLink) {

//           el.removeAttribute('tabindex');

//           el.removeAttribute('aria-hidden');

//         } else {

//           el.setAttribute('tabindex', '-1');

//           if (isImageLink) el.setAttribute('aria-hidden', 'true');

//         }

//       });

//     });
 
//     // If focus was inside a slide that just scrolled away, keep it on the Next button

//     if (focusLost) {

//       var next = slider.querySelector('.slick-next');

//       if (next) next.focus();

//     }
 
//     if (announce && active.length) {

//       active.sort(function (a, b) { return a.position - b.position; });

//       var first = active[0].position;

//       var last = active[active.length - 1].position;

//       var range = active.length === 1

//         ? 'Showing item ' + first + ' of ' + total

//         : 'Showing items ' + first + ' to ' + last + ' of ' + total;

//       var names = active.map(function (s) { return s.title; }).filter(Boolean).join(', ');

//       var region = liveRegion(slider);

//       region.textContent = '';

//       setTimeout(function () { region.textContent = range + (names ? ': ' + names : ''); }, 100);

//     }

//   }
 
//   onReady(function () {

//     var $ = window.jQuery;

//     if (!$) return;
 
//     // Run after Slick's own accessibility pass, which resets tabindex/aria-live.

//     function later(slider, announce) {

//       setTimeout(function () { setup(slider); update(slider, announce); }, 0);

//     }
 
//     $(document).on('init reInit breakpoint setPosition', SELECTOR, function (e) {

//       if (e.target === this) later(this, false);

//     });

//     $(document).on('afterChange', SELECTOR, function (e) {

//       if (e.target === this) later(this, true);

//     });
 
//     // Sliders initialised before this script loaded

//     $(SELECTOR + '.slick-initialized').each(function () { later(this, false); });

//   });

// })();
  





////////////////// Sort by filters 

document.querySelectorAll('.toolbar-sort').forEach(function (toolbar) {
  var trigger = toolbar.querySelector(
    '.filter-sortby .label-tab[role="button"]'
  );

  var menu = toolbar.querySelector('.dropdown-menu');

  if (!trigger || !menu) return;

  // START: Add an accessible name to the sort trigger
  var label = toolbar.querySelector('.toolbar-label');

  if (label) {
    if (!label.id) {
      label.id = 'sort-by-label-' + Math.random().toString(36).slice(2, 9);
    }

    trigger.setAttribute('aria-labelledby', label.id);
  }
  // END: Add an accessible name to the sort trigger

  // START: Add keyboard support to open and close the menu
  trigger.setAttribute('tabindex', '0');
  trigger.setAttribute('aria-haspopup', 'true');

  if (!trigger.hasAttribute('aria-expanded')) {
    trigger.setAttribute('aria-expanded', 'false');
  }

  trigger.addEventListener('keydown', function (event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      trigger.click();
    }

    if (event.key === 'Escape') {
      event.preventDefault();

      if (menu.classList.contains('show') ||
          menu.classList.contains('open') ||
          trigger.getAttribute('aria-expanded') === 'true') {
        trigger.click();
        trigger.setAttribute('aria-expanded', 'false');
        trigger.focus();
      }
    }
  });
  // END: Add keyboard support to open and close the menu

  // START: Make sorting options keyboard-accessible
  menu.querySelectorAll('[data-sort-by-item] .text').forEach(
    function (option) {
      option.setAttribute('tabindex', '0');

      option.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          option.click();
        }

        if (event.key === 'Escape') {
          event.preventDefault();
          trigger.click();
          trigger.setAttribute('aria-expanded', 'false');
          trigger.focus();
        }
      });
    }
  );
  // END: Make sorting options keyboard-accessible
});


/////////============================ Js for search categories 
window.addEventListener('load', function () {
  var live = document.createElement('div');
  live.setAttribute('role', 'status');
  live.setAttribute('aria-live', 'polite');
  live.style.cssText = 'position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0,0,0,0)';
  document.body.appendChild(live);

  function sync(h, say) {
    var open = h.classList.contains('is-clicked');
    h.setAttribute('aria-expanded', open);
    if (say) live.textContent = h.textContent.trim() + (open ? ' expanded' : ' collapsed');
  }

  setTimeout(function () {
    document.querySelectorAll('.sidebarBlock-heading').forEach(function (h) {
      h.addEventListener('click', function () { setTimeout(function () { sync(h, true); }, 0); });
      h.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); h.click(); }
      });
      if (!h.classList.contains('is-clicked')) h.click(); // open on first load
      setTimeout(function () { sync(h, false); }, 0);
    });
  }, 300);
});

/// Js for out of stock product 
document.querySelectorAll('.card-action .button-ATC').forEach(function (button) {
    if (button.textContent.trim().toLowerCase() === 'out of stock') {
        var productCard = button.closest('.card, .card-item, .product-item');
        var productTitle = productCard?.querySelector('.card-title, .product-title, .card-information__text')?.textContent.trim();

        if (productTitle) {
            button.setAttribute('aria-label', 'Out of stock: ' + productTitle);
        }
    }
});

// Removes aria-labelledby so the control does not override its accessible name.
function removeAriaLabelledby() {
    document.querySelectorAll('.toolbar-sort .label-tab[aria-labelledby]')
        .forEach(function (element) {
            element.removeAttribute('aria-labelledby');
        });
}

removeAriaLabelledby();

/// JS for autoplay slider  in blogs 
// START: Disable autoplay on initialized Slick sliders
function disableSlickAutoplay() {
  document.querySelectorAll('.slick-slider').forEach(function (slider) {
    var slickInstance = slider.slick || slider.slickInstance;

    if (slickInstance && typeof slickInstance.pause === 'function') {
      slickInstance.pause();
    }
  });
}

disableSlickAutoplay();
// END: Disable autoplay on initialized Slick sliders



//   end of dom
});